module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-testimonial-4.33ef8cfc.webp";